import script from "./TaskBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./TaskBase.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItemSection,QList,QItem,QItemLabel});
